
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class inAppNotificationsModal extends Vue {

    notifications: OM.InAppNotification[] = [];

    created(){
        InAppNotificationClient.getAllByUser(store.state.user.identifier)
        .then(x => {
            this.notifications = x;
        })
    }

    setAllAsRead(){
        InAppNotificationClient.setAllRead(store.state.user.identifier)
        .then(x => {
            this.$emit('close');
        })
    }

    setReadAndClose(item: OM.InAppNotification){
        InAppNotificationClient.setRead(item.identifier);
        store.state.inAppNotificationsCount--;
        this.$emit('close');
    }

}
